import React, { useState } from 'react';
import { useAppContext } from '../../contexts/AppContext';
import BottomSheetSelect from '../BottomSheetSelect/BottomSheetSelect.js';
import { ReactSVG } from 'react-svg';
import Barcode from 'react-barcode';

import './CustomerBarcode.css';

const CustomerBarcode = () => {
    
    const { appRef } = useAppContext();
    const [isOpen, setIsOpen] = useState(false);

    if(!appRef.current.state.is_signed) {
        return null; // Nem jelenít meg semmit, ha a felhasználó nincs bejelentkezve
    }

    const customer_barcode = appRef.current.state.user_data?.customer_code || '';

    const handleOpen = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div className="customer-barcode" onClick={handleOpen}>
                <ReactSVG src="/assets/images/barcode.svg" />
            </div>
            
            <BottomSheetSelect
                isOpen={isOpen}
                onClose={handleClose}
                title="Törzsvásárlói kódod"
            >
                <div className="customer-barcode-display">
                    <p>Olvasd be a kódod, amikor üzletben vásárolsz.<br/>Így a vásárlási előzményeid is rögzítésre kerülnek.</p>
                    <div className="barcode-image">
                        <Barcode value={customer_barcode} format="CODE128" />   
                    </div>
                </div>
            </BottomSheetSelect>
        </>
    );
};

export default CustomerBarcode;
